import { dispatch } from '../../createStore';
import { UPDATE_SEARCH_VALUE } from '../types/createSearch.type';

export const updateSearchValue = (v: string) => {
  dispatch({ type: UPDATE_SEARCH_VALUE, payload: v });
};
